import type { CiActividadResponse } from '@supernova/shared';
import { apiFetch } from './client.js';

/** «Actividad de OPUS ci» (solo staff Ecosoft). Forma: `CiActividadResponse` en shared. */
export function getCiActividad(dias = 30): Promise<CiActividadResponse> {
  return apiFetch<CiActividadResponse>(`/api/v1/staff/ci/actividad?dias=${dias}`);
}
